import * as XLSX from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ProgramCatalogueService } from './program-catalogue.service';
import { Component, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EmployeeCareerProgramService } from '../employee-career-program/employee-career-program.service';
import { CareerPathService } from '../employee-career-path/employee-career-path.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export interface User {
  employeeName: string,
  userId: string
}

@Component({
  selector: 'app-program-catalogue',
  templateUrl: './program-catalogue.component.html',
  styleUrls: ['./program-catalogue.component.css']
})
export class ProgramCatalogueComponent {

  allPrograms: any;
  showAllViewMore = true;
  allProgramsSearch: string = '';
  allProgramsPageNumber: number = 1;

  pageSize: number = 8;
  private _totalRecords: number = 0;
  get totalRecords(): number {
    return this._totalRecords;
  }
  set totalRecords(value: number) {
    this._totalRecords = value;
  }
  gridView: boolean = false;
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['ProgramName', 'Department', 'ComplexityLevel', 'TotalCourses', 'TotalHours', 'TotalTopics', 'Actions'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  elasticSearchPrograms = [];
  elasticSearchProgarmIds = [0];
  isloading: boolean=false;
  isCareerPathPrograms: string = '';

  @ViewChild('elasticSearch', { read: MatAutocompleteTrigger })
  autoComplete: MatAutocompleteTrigger;

  private searchSubject: Subject<string> = new Subject<string>();


  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private service: EmployeeCareerProgramService, private route: Router, private careerPathservice: CareerPathService,
    private programService: ProgramCatalogueService) {
    this.isCareerPathPrograms = window.history.state.selectedGrade || '';
  }
  private getRecordsCount(response: any[]): number {
    if (!response || response.length === 0) {
      return 0;
    }
    const firstRecord = response[0];
    if (firstRecord.RecordsCount !== undefined) {
      return firstRecord.RecordsCount;
    }
    if (firstRecord.recordsCount !== undefined) {
      return firstRecord.recordsCount;
    }
    if (firstRecord.recordscount !== undefined) {
      return firstRecord.recordscount;
    }
    return response.length;
  }

  ngOnInit(): void {
    this.isCareerPathPrograms ? this.careerPathservice.careerPathProgramIds.subscribe(data => this.elasticSearchProgarmIds = data) : '';
    this.getAllPrograms();
    this.initDebounce();
  }
  ngAfterViewInit(): void {
    if (this.paginator && this.dataSource) {
      this.dataSource.paginator = this.paginator;
    }
  }

  initDebounce() {
    this.searchSubject.pipe(
      debounceTime(1000)
    ).subscribe(searchText => {
      this.searchAllPrograms(searchText);
    });
  }
  onSearchTextChanged(searchText: string) {
    this.allProgramsSearch = searchText;
    this.searchSubject.next(searchText);
  }
  clearSearchProgramText(event) {
    event.value = "";
    this.allProgramsSearch = "";
    this.allProgramsPageNumber = 1;
    this.allPrograms = [];
    this.getAllPrograms();
  }
  clearSearch(event) {
    if (event == "") {
      this.allProgramsSearch = "";
      this.allProgramsPageNumber = 1;
      this.allPrograms = [];
      this.getAllPrograms();
    }
  }
  searchAllPrograms(data: any) {
    this.allPrograms = [];
    this.allProgramsPageNumber = 1;
    var model = {
      searchKey: data,
      pageSize: this.pageSize,
      pageNumber: this.allProgramsPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    this.isloading=true;
    this.spinner.show();
    this.service.getAllPrograms(model).subscribe((res: any[]) => {
      if (res) {
        if (res.length < 8) {
          this.showAllViewMore = false;
        }
        if (res.length === 8) {
          this.showAllViewMore = true;
        }
        if (res.length >= 0) {
          this.allProgramsPageNumber += 1;
          this.allPrograms = Array.from(res);
          this.totalRecords = this.getRecordsCount(res);
          if (this.gridView) {
            this.updateTableDataSource();
          }
        }

      } else {
        this.allPrograms = [];
        this.totalRecords = 0;
        if (this.gridView) {
          this.updateTableDataSource();
        }
      }
      this.spinner.hide();
      this.isloading=false;

    }, error => {
      console.error('Error in searchAllPrograms:', error);
      this.spinner.hide();
      this.isloading=false;
      this.toastr.error("Data Fetching Failed")
      this.allPrograms = [];
      this.totalRecords = 0;
      if (this.gridView) {
        this.updateTableDataSource();
      }
    });
  }

  loadAllPrograms() {
    var model = {
      searchKey: this.allProgramsSearch,
      pageSize: this.pageSize,
      pageNumber: this.allProgramsPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    this.isloading=true;
    this.spinner.show();
    this.service.getAllPrograms(model).subscribe((res: any[]) => {
      if (res) {
        if (res.length < 8) {
          this.showAllViewMore = false;
        }
        if (res.length === 8) {
          this.showAllViewMore = true;
        }
        if (res.length >= 0) {
          this.allProgramsPageNumber += 1;
          var x = Array.from(res);
          this.allPrograms = Array.from(this.allPrograms);
          x.forEach(program => {
            this.allPrograms.push(program);
          })
          this.totalRecords = this.getRecordsCount(res);
          if (this.gridView) {
            this.updateTableDataSource();
          }
        }
        this.spinner.hide();
        this.isloading=false;

      } else {
        this.spinner.hide();
        this.isloading=false;
      }
    }, error => {
      console.error('Error in loadAllPrograms:', error);
      this.spinner.hide();
      this.isloading=false;
      this.toastr.error("Data Fetching Failed")
    })
  }

  getAllPrograms() {
    var model = {
      searchKey: this.allProgramsSearch,
      pageSize: this.pageSize,
      pageNumber: this.allProgramsPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    this.isloading=true;
    this.spinner.show();
    this.service.getAllPrograms(model).subscribe((res: any[]) => {      
      if (res) {
        this.allProgramsPageNumber += 1;
        this.allPrograms = res;
        this.totalRecords = this.getRecordsCount(res);
        this.updateTableDataSource();
      } else {
        this.totalRecords = 0;
        this.allPrograms = [];
        this.updateTableDataSource();
      }

      this.spinner.hide();
      this.isloading=false;
    }, error => {
      console.error('Error fetching programs:', error);
      this.spinner.hide();
      this.isloading=false;
      this.toastr.error("Data Fetching Failed")
      this.totalRecords = 0;
      this.allPrograms = [];
      this.updateTableDataSource();
    })
  }
  updateTableDataSource() {
    if (!this.dataSource) {
      this.dataSource = new MatTableDataSource(this.allPrograms);
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    } else {
      this.dataSource.data = this.allPrograms;
    }
  }
  initializeTableView() {
    if (this.gridView) {
      this.allProgramsPageNumber = 1;
      this.pageSize = 8;
      this.getAllPrograms();
    }
  }
  refreshData() {
    this.allProgramsPageNumber = 1;
    this.allProgramsSearch = '';
    this.getAllPrograms();
  }
  getPaginatorData(event: any) {
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    const apiPageNumber = pageIndex + 1;
    
    var model = {
      searchKey: this.allProgramsSearch,
      pageSize: pageSize,
      pageNumber: apiPageNumber,
      programIds: this.elasticSearchProgarmIds
    }
    
    this.isloading = true;
    this.spinner.show();
    
    this.service.getAllPrograms(model).subscribe((res: any[]) => {
      if (res) {
        this.allPrograms = res;
        this.totalRecords = this.getRecordsCount(res);
        this.updateTableDataSource();
      } else {
        this.totalRecords = 0;
        this.allPrograms = [];
        this.updateTableDataSource();
      }
      this.spinner.hide();
      this.isloading = false;
    }, error => {
      console.error('Error in paginator:', error);
      this.spinner.hide();
      this.isloading = false;
      this.toastr.error("Data Fetching Failed")
      this.totalRecords = 0;
      this.allPrograms = [];
      this.updateTableDataSource();
    });
  }

  goToProgramDetails(program) {
    const selectedGrade = window.history.state.selectedGrade;
    this.isCareerPathPrograms ?
      this.route.navigateByUrl('Home/employee-career/employee-Career-path/program-catalogue/' + program.programID, { state: { prevUrl: 'Home/employee-career/employee-Career-path/program-catalogue', selectedGrade:selectedGrade } }) : this.route.navigateByUrl('Home/employee-career/program-catalogue/' + program.programID);
  }

  goToProgramDetail(program) {
    this.route.navigateByUrl('Home/employee-career/employee-Career-program/' + program.programId, { state: { prevUrl: 'pc' } });
  }

  employeeCareerPathNavigate() {
    this.route.navigateByUrl('Home/employee-career/employee-Career-path');
  }
  exportToExcel(): void {
    this.programService.getAllProgramsInExport().subscribe({
      next: (response: any[]) => {
        if (!response || response.length === 0) {
          this.toastr.warning('No programs available to export');
          return;
        }
  
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(response.map(program => ({
          ProgramName: program.programName,
          Department: program.departmentPathName || program.subGroup || 'N/A',
          ComplexityLevel: program.complexityLevel,
          TotalCourses: program.totalCourses,
          TotalHours: program.totalTopicsLength,
          TotalTopics: program.totalTopics
        })));
  
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Programs': worksheet },
          SheetNames: ['Programs']
        };
  
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
        XLSX.writeFile(workbook, `ProgramCatalogue-${timestamp}.xlsx`);
      },
      error: (err) => {
        this.toastr.error('Failed to fetch programs for export');
        console.error('Export error:', err);
      }
    });
  }

  exportIndividualProgramToExcel(program: any, event: Event): void {
    event.stopPropagation(); // Prevent card click when export button is clicked
    
    this.spinner.show();
    this.service.GetEmployeeProgramDetail(program.programID || program.programId, 0).subscribe({
      next: (response: any) => {
        if (!response) {
          this.toastr.warning('No program details available to export');
          this.spinner.hide();
          return;
        }

        // Create program data with only the requested fields
        const programData = {
          ProgramName: response.programName || program.programName,
          Department: response.departmentPathName || program.departmentPathName || program.subGroup || 'N/A',
          ComplexityLevel: response.complexityLevel || program.complexityLevel,
          TotalCourses: response.courses?.length || program.totalCourses,
          TotalHours: response.totalTopicsLength || program.totalTopicsLength,
          TotalTopics: response.totalTopics || program.totalTopics,
        };

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([programData]);
        
        // Auto-size columns
        const columnWidths = Object.keys(programData).map(key => ({ wch: Math.max(key.length, 15) }));
        worksheet['!cols'] = columnWidths;

        const workbook: XLSX.WorkBook = {
          Sheets: { 'ProgramDetails': worksheet },
          SheetNames: ['ProgramDetails']
        };

        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
        const fileName = `${programData.ProgramName.replace(/[^a-zA-Z0-9]/g, '_')}-${timestamp}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        
        this.spinner.hide();
        this.toastr.success('Program details exported successfully');
      },
      error: (err) => {
        this.spinner.hide();
        this.toastr.error('Failed to fetch program details for export');
        console.error('Individual program export error:', err);
      }
    });
  }
  
  toggleView(type: string) { 
    this.pageSize = 8;
    if (type === 'table') { 
      this.gridView = true; 
      this.pageSize = 8;
      this.initializeTableView();
    } 
    else if (type === 'grid') { 
      this.gridView = false;
    }
  }
}

